__turbopack_context__.v({
  "b": "styles-module-scss-module__togebW__b",
  "container": "styles-module-scss-module__togebW__container",
  "fb": "styles-module-scss-module__togebW__fb",
  "fbn": "styles-module-scss-module__togebW__fbn",
});
